import Contact from "@modules/ErrorFallback/Contact";
import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import PageWrapper from "../PageWrapper";
import BuildFlag from "./BuildFlag";
import ContactExpert from "./ContactExpert";

interface Props {}
const ErrorFallback: React.FC<Props> = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY || ""}
    >
      <PageWrapper>
        <Contact />
        <BuildFlag />
        <ContactExpert />
      </PageWrapper>
    </GoogleReCaptchaProvider>
  );
};

export default ErrorFallback;
